export default "__VITE_ASSET__DW_XB6v3__"